var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "single__service-modal" }, [
    _c(
      "div",
      {
        staticClass: "single__modal-btn-wraper single__modal-btn-wraper--2",
        on: { click: _vm.toggleSidebar }
      },
      [
        _c("div", { staticClass: "single__modal-btn-left" }, [
          _vm.deliveryMapping === 4
            ? _c("div", {
                staticClass: "single__modal-btn-icon",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "Weberbuero::Template.serviceModalOpenBtnIconSpedition"
                    )
                  )
                }
              })
            : _vm.deliveryMapping === 16
            ? _c("div", {
                staticClass: "single__modal-btn-icon",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "Weberbuero::Template.serviceModalOpenBtnIconSpedition"
                    )
                  )
                }
              })
            : _vm.deliveryMapping === 6
            ? _c("div", {
                staticClass: "single__modal-btn-icon",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "Weberbuero::Template.serviceModalOpenBtnIconPaketversandDhl"
                    )
                  )
                }
              })
            : _vm.deliveryMapping === 20
            ? _c("div", {
                staticClass: "single__modal-btn-icon",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "Weberbuero::Template.serviceModalOpenBtnIconGLS"
                    )
                  )
                }
              })
            : _vm.deliveryMapping === 8
            ? _c("div", {
                staticClass: "single__modal-btn-icon",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "Weberbuero::Template.serviceModalOpenBtnIconAbholung"
                    )
                  )
                }
              })
            : _c("div", {
                staticClass: "single__modal-btn-icon",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "Weberbuero::Template.serviceModalOpenBtnIcon"
                    )
                  )
                }
              }),
          _vm._v(" "),
          _vm.deliveryMapping === 4
            ? _c("div", { staticClass: "single__modal-btn-text" }, [
                _c("div", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceModalOpenBtnLeftPaketversandDhl"
                        )
                      ) +
                      "\n\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  ((_vm.currentVariation.variation.isMain &&
                    !_vm.currentVariation.filter.hasActiveChildren) ||
                    (!_vm.currentVariation.variation.isMain &&
                      !_vm.currentVariation.filter.hasActiveChildren)) &&
                  _vm.currentVariation.stock.net > 0 &&
                  _vm.currentVariation.variation.availability.id === 1
                    ? _c("span", {
                        staticClass: "single__stock",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.currentVariation.stock.net +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDeliveryStock"
                              )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVariation.variation.availability
                    ? _c("span", {
                        staticClass: "single__availability",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate(
                              "Weberbuero::Template.quickViewDelivery1"
                            ) +
                              " " +
                              _vm.currentVariation.variation.availability.names
                                .name +
                              (_vm.currentVariation.variation.availability
                                .id === 1
                                ? "n"
                                : "") +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDelivery2"
                              )
                          )
                        }
                      })
                    : _vm._e()
                ])
              ])
            : _vm.deliveryMapping === 16
            ? _c("div", { staticClass: "single__modal-btn-text" }, [
                _c("div", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceModalOpenBtnLeftSpedition"
                        )
                      ) +
                      "\n\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  ((_vm.currentVariation.variation.isMain &&
                    !_vm.currentVariation.filter.hasActiveChildren) ||
                    (!_vm.currentVariation.variation.isMain &&
                      !_vm.currentVariation.filter.hasActiveChildren)) &&
                  _vm.currentVariation.stock.net > 0 &&
                  _vm.currentVariation.variation.availability.id === 1
                    ? _c("span", {
                        staticClass: "single__stock",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.currentVariation.stock.net +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDeliveryStock"
                              )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVariation.variation.availability
                    ? _c("span", {
                        staticClass: "single__availability",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate(
                              "Weberbuero::Template.quickViewDelivery1"
                            ) +
                              " " +
                              _vm.currentVariation.variation.availability.names
                                .name +
                              (_vm.currentVariation.variation.availability
                                .id === 1
                                ? "n"
                                : "") +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDelivery2"
                              )
                          )
                        }
                      })
                    : _vm._e()
                ])
              ])
            : _vm.deliveryMapping === 6
            ? _c("div", { staticClass: "single__modal-btn-text" }, [
                _c("div", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceModalOpenBtnLeftPaketversandDhl"
                        )
                      ) +
                      "\n\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  ((_vm.currentVariation.variation.isMain &&
                    !_vm.currentVariation.filter.hasActiveChildren) ||
                    (!_vm.currentVariation.variation.isMain &&
                      !_vm.currentVariation.filter.hasActiveChildren)) &&
                  _vm.currentVariation.stock.net > 0 &&
                  _vm.currentVariation.variation.availability.id === 1
                    ? _c("span", {
                        staticClass: "single__stock",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.currentVariation.stock.net +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDeliveryStock"
                              )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVariation.variation.availability
                    ? _c("span", {
                        staticClass: "single__availability",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate(
                              "Weberbuero::Template.quickViewDelivery1"
                            ) +
                              " " +
                              _vm.currentVariation.variation.availability.names
                                .name +
                              (_vm.currentVariation.variation.availability
                                .id === 1
                                ? "n"
                                : "") +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDelivery2"
                              )
                          )
                        }
                      })
                    : _vm._e()
                ])
              ])
            : _vm.deliveryMapping === 20
            ? _c("div", { staticClass: "single__modal-btn-text" }, [
                _c("div", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceModalOpenBtnLeftGLS"
                        )
                      ) +
                      "\n\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  ((_vm.currentVariation.variation.isMain &&
                    !_vm.currentVariation.filter.hasActiveChildren) ||
                    (!_vm.currentVariation.variation.isMain &&
                      !_vm.currentVariation.filter.hasActiveChildren)) &&
                  _vm.currentVariation.stock.net > 0 &&
                  _vm.currentVariation.variation.availability.id === 1
                    ? _c("span", {
                        staticClass: "single__stock",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.currentVariation.stock.net +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDeliveryStock"
                              )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVariation.variation.availability
                    ? _c("span", {
                        staticClass: "single__availability",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate(
                              "Weberbuero::Template.quickViewDelivery1"
                            ) +
                              " " +
                              _vm.currentVariation.variation.availability.names
                                .name +
                              (_vm.currentVariation.variation.availability
                                .id === 1
                                ? "n"
                                : "") +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDelivery2"
                              )
                          )
                        }
                      })
                    : _vm._e()
                ])
              ])
            : _vm.deliveryMapping === 8
            ? _c("div", { staticClass: "single__modal-btn-text" }, [
                _c("div", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceModalOpenBtnLeftAbholung"
                        )
                      ) +
                      "\n\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  ((_vm.currentVariation.variation.isMain &&
                    !_vm.currentVariation.filter.hasActiveChildren) ||
                    (!_vm.currentVariation.variation.isMain &&
                      !_vm.currentVariation.filter.hasActiveChildren)) &&
                  _vm.currentVariation.stock.net > 0 &&
                  _vm.currentVariation.variation.availability.id === 1
                    ? _c("span", {
                        staticClass: "single__stock",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.currentVariation.stock.net +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDeliveryStock"
                              )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVariation.variation.availability
                    ? _c("span", {
                        staticClass: "single__availability",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate(
                              "Weberbuero::Template.quickViewDelivery1"
                            ) +
                              " " +
                              _vm.currentVariation.variation.availability.names
                                .name +
                              (_vm.currentVariation.variation.availability
                                .id === 1
                                ? "n"
                                : "") +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDelivery2"
                              )
                          )
                        }
                      })
                    : _vm._e()
                ])
              ])
            : _c("div", { staticClass: "single__modal-btn-text" }, [
                _c("div", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceModalOpenBtnLeft"
                        )
                      ) +
                      "\n\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  ((_vm.currentVariation.variation.isMain &&
                    !_vm.currentVariation.filter.hasActiveChildren) ||
                    (!_vm.currentVariation.variation.isMain &&
                      !_vm.currentVariation.filter.hasActiveChildren)) &&
                  _vm.currentVariation.stock.net > 0 &&
                  _vm.currentVariation.variation.availability.id === 1
                    ? _c("span", {
                        staticClass: "single__stock",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.currentVariation.stock.net +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDeliveryStock"
                              )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVariation.variation.availability
                    ? _c("span", {
                        staticClass: "single__availability",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate(
                              "Weberbuero::Template.quickViewDelivery1"
                            ) +
                              " " +
                              _vm.currentVariation.variation.availability.names
                                .name +
                              (_vm.currentVariation.variation.availability
                                .id === 1
                                ? "n"
                                : "") +
                              " " +
                              _vm.$translate(
                                "Weberbuero::Template.quickViewDelivery2"
                              )
                          )
                        }
                      })
                    : _vm._e()
                ])
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "single__modal-link" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.$translate("Weberbuero::Template.serviceModalOpenBtnRight")
              ) +
              "\n                "
          ),
          _c("i", { staticClass: "fa fa-angle-right" })
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "service-sidebar__wrapper" }, [
      _c("div", {
        staticClass: "service-sidebar__backdrop",
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.toggleSidebar.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "service-sidebar__container" }, [
        _c("div", { staticClass: "service-sidebar__content" }, [
          _c("div", { staticClass: "service-sidebar__header" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$translate("Weberbuero::Template.serviceSidebarHeadline")
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: {
                  type: "button",
                  "aria-label": _vm.$translate("Ceres::Template.closeIcon")
                },
                on: { click: _vm.toggleSidebar }
              },
              [
                _c("svg", { attrs: { height: "26", width: "27" } }, [
                  _c("use", {
                    attrs: {
                      "xlink:href": "#svg_close",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }
                  })
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown__wrapper" }, [
            _c("div", { staticClass: "dropdown__headline" }, [
              _vm._v(
                _vm._s(
                  _vm.$translate(
                    "Weberbuero::Template.serviceSidebarCountryHeadline"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown__header",
                class: { open: _vm.openDropdown },
                on: {
                  click: function($event) {
                    _vm.openDropdown = !_vm.openDropdown
                  }
                }
              },
              [
                _vm.activeLang != "contact"
                  ? _c(
                      "span",
                      [
                        _c("i", {
                          class: "flag-icon flag-icon-" + _vm.activeLang
                        }),
                        _vm._v(" "),
                        _vm.activeLang === "de"
                          ? [_vm._v("Deutschland")]
                          : _vm.activeLang === "it"
                          ? [_vm._v("Italien")]
                          : _vm.activeLang === "at"
                          ? [_vm._v("Österreich")]
                          : [_vm._v(_vm._s(_vm.activeLang))]
                      ],
                      2
                    )
                  : _c("span", [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("g", { attrs: { id: "fi_471664" } }, [
                            _c("g", { attrs: { id: "Vector" } }, [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M8 2C4.6838 2 2 4.6835 2 8C2 11.3161 4.6835 14 8 14C11.3162 14 14 11.3165 14 8C14 4.6838 11.3165 2 8 2ZM8 13.1628C5.15323 13.1628 2.83721 10.8468 2.83721 8C2.83721 5.15321 5.15323 2.83721 8 2.83721C10.8468 2.83721 13.1628 5.15321 13.1628 8C13.1628 10.8468 10.8468 13.1628 8 13.1628Z",
                                  fill: "black"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M7.8224 9.59192C7.49069 9.59192 7.22217 9.86834 7.22217 10.2C7.22217 10.5239 7.48279 10.8082 7.8224 10.8082C8.16201 10.8082 8.43051 10.5239 8.43051 10.2C8.43051 9.86834 8.15409 9.59192 7.8224 9.59192Z",
                                  fill: "black"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M7.9255 4.98755C6.85928 4.98755 6.36963 5.6194 6.36963 6.04587C6.36963 6.35388 6.63025 6.49606 6.84349 6.49606C7.26998 6.49606 7.09624 5.8879 7.90181 5.8879C8.29668 5.8879 8.61262 6.06167 8.61262 6.42497C8.61262 6.85144 8.17033 7.09627 7.90971 7.3174C7.68065 7.51481 7.38056 7.83865 7.38056 8.51787C7.38056 8.92854 7.49114 9.04702 7.81493 9.04702C8.2019 9.04702 8.28089 8.87328 8.28089 8.72318C8.28089 8.31251 8.28878 8.07558 8.72318 7.73597C8.93641 7.57013 9.60771 7.03306 9.60771 6.29067C9.60771 5.54829 8.93641 4.98755 7.9255 4.98755Z",
                                  fill: "black"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M8 2C4.6838 2 2 4.6835 2 8C2 11.3161 4.6835 14 8 14C11.3162 14 14 11.3165 14 8C14 4.6838 11.3165 2 8 2ZM8 13.1628C5.15323 13.1628 2.83721 10.8468 2.83721 8C2.83721 5.15321 5.15323 2.83721 8 2.83721C10.8468 2.83721 13.1628 5.15321 13.1628 8C13.1628 10.8468 10.8468 13.1628 8 13.1628Z",
                                  stroke: "black",
                                  "stroke-width": "0.3"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M7.8224 9.59192C7.49069 9.59192 7.22217 9.86834 7.22217 10.2C7.22217 10.5239 7.48279 10.8082 7.8224 10.8082C8.16201 10.8082 8.43051 10.5239 8.43051 10.2C8.43051 9.86834 8.15409 9.59192 7.8224 9.59192Z",
                                  stroke: "black",
                                  "stroke-width": "0.3"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M7.9255 4.98755C6.85928 4.98755 6.36963 5.6194 6.36963 6.04587C6.36963 6.35388 6.63025 6.49606 6.84349 6.49606C7.26998 6.49606 7.09624 5.8879 7.90181 5.8879C8.29668 5.8879 8.61262 6.06167 8.61262 6.42497C8.61262 6.85144 8.17033 7.09627 7.90971 7.3174C7.68065 7.51481 7.38056 7.83865 7.38056 8.51787C7.38056 8.92854 7.49114 9.04702 7.81493 9.04702C8.2019 9.04702 8.28089 8.87328 8.28089 8.72318C8.28089 8.31251 8.28878 8.07558 8.72318 7.73597C8.93641 7.57013 9.60771 7.03306 9.60771 6.29067C9.60771 5.54829 8.93641 4.98755 7.9255 4.98755Z",
                                  stroke: "black",
                                  "stroke-width": "0.3"
                                }
                              })
                            ])
                          ])
                        ]
                      ),
                      _vm._v(
                        "\n\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "Weberbuero::Template.serviceSidebarCountryNotFound"
                            )
                          ) +
                          "\n                  "
                      )
                    ]),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "ddown-arrow",
                    attrs: {
                      width: "12",
                      height: "8",
                      viewBox: "0 0 12 8",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        id: "01 shape",
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d:
                          "M11.0024 0.400391L6 5.54733L0.997554 0.400391L0 1.42676L6 7.60006L12 1.42676L11.0024 0.400391Z",
                        fill: "#9B9B9B"
                      }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown__list",
                class: { open: _vm.openDropdown }
              },
              [
                _vm._l(_vm.shippingGroup, function(value, key, index) {
                  return _c(
                    "div",
                    {
                      staticClass: "dropdown__list-item",
                      class: { active: key === _vm.activeLang },
                      on: {
                        click: function($event) {
                          _vm.activeLang = key
                          _vm.openDropdown = !_vm.openDropdown
                        }
                      }
                    },
                    [
                      _c("i", { class: "flag-icon flag-icon-" + key }),
                      _vm._v(" "),
                      key === "de"
                        ? [_vm._v("Deutschland")]
                        : key === "it"
                        ? [_vm._v("Italien")]
                        : key === "at"
                        ? [_vm._v("Österreich")]
                        : key === "be"
                        ? [_vm._v("Belgien")]
                        : key === "nl"
                        ? [_vm._v("Niederlande")]
                        : key === "lux"
                        ? [_vm._v("Luxemburg")]
                        : [_vm._v(_vm._s(key))]
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown__list-item",
                    class: { active: "contact" === _vm.activeLang },
                    on: {
                      click: function($event) {
                        _vm.activeLang = "contact"
                        _vm.openDropdown = !_vm.openDropdown
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 16 16",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("g", { attrs: { id: "fi_471664" } }, [
                          _c("g", { attrs: { id: "Vector" } }, [
                            _c("path", {
                              attrs: {
                                d:
                                  "M8 2C4.6838 2 2 4.6835 2 8C2 11.3161 4.6835 14 8 14C11.3162 14 14 11.3165 14 8C14 4.6838 11.3165 2 8 2ZM8 13.1628C5.15323 13.1628 2.83721 10.8468 2.83721 8C2.83721 5.15321 5.15323 2.83721 8 2.83721C10.8468 2.83721 13.1628 5.15321 13.1628 8C13.1628 10.8468 10.8468 13.1628 8 13.1628Z",
                                fill: "black"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M7.8224 9.59192C7.49069 9.59192 7.22217 9.86834 7.22217 10.2C7.22217 10.5239 7.48279 10.8082 7.8224 10.8082C8.16201 10.8082 8.43051 10.5239 8.43051 10.2C8.43051 9.86834 8.15409 9.59192 7.8224 9.59192Z",
                                fill: "black"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M7.9255 4.98755C6.85928 4.98755 6.36963 5.6194 6.36963 6.04587C6.36963 6.35388 6.63025 6.49606 6.84349 6.49606C7.26998 6.49606 7.09624 5.8879 7.90181 5.8879C8.29668 5.8879 8.61262 6.06167 8.61262 6.42497C8.61262 6.85144 8.17033 7.09627 7.90971 7.3174C7.68065 7.51481 7.38056 7.83865 7.38056 8.51787C7.38056 8.92854 7.49114 9.04702 7.81493 9.04702C8.2019 9.04702 8.28089 8.87328 8.28089 8.72318C8.28089 8.31251 8.28878 8.07558 8.72318 7.73597C8.93641 7.57013 9.60771 7.03306 9.60771 6.29067C9.60771 5.54829 8.93641 4.98755 7.9255 4.98755Z",
                                fill: "black"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M8 2C4.6838 2 2 4.6835 2 8C2 11.3161 4.6835 14 8 14C11.3162 14 14 11.3165 14 8C14 4.6838 11.3165 2 8 2ZM8 13.1628C5.15323 13.1628 2.83721 10.8468 2.83721 8C2.83721 5.15321 5.15323 2.83721 8 2.83721C10.8468 2.83721 13.1628 5.15321 13.1628 8C13.1628 10.8468 10.8468 13.1628 8 13.1628Z",
                                stroke: "black",
                                "stroke-width": "0.3"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M7.8224 9.59192C7.49069 9.59192 7.22217 9.86834 7.22217 10.2C7.22217 10.5239 7.48279 10.8082 7.8224 10.8082C8.16201 10.8082 8.43051 10.5239 8.43051 10.2C8.43051 9.86834 8.15409 9.59192 7.8224 9.59192Z",
                                stroke: "black",
                                "stroke-width": "0.3"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M7.9255 4.98755C6.85928 4.98755 6.36963 5.6194 6.36963 6.04587C6.36963 6.35388 6.63025 6.49606 6.84349 6.49606C7.26998 6.49606 7.09624 5.8879 7.90181 5.8879C8.29668 5.8879 8.61262 6.06167 8.61262 6.42497C8.61262 6.85144 8.17033 7.09627 7.90971 7.3174C7.68065 7.51481 7.38056 7.83865 7.38056 8.51787C7.38056 8.92854 7.49114 9.04702 7.81493 9.04702C8.2019 9.04702 8.28089 8.87328 8.28089 8.72318C8.28089 8.31251 8.28878 8.07558 8.72318 7.73597C8.93641 7.57013 9.60771 7.03306 9.60771 6.29067C9.60771 5.54829 8.93641 4.98755 7.9255 4.98755Z",
                                stroke: "black",
                                "stroke-width": "0.3"
                              }
                            })
                          ])
                        ])
                      ]
                    ),
                    _vm._v(
                      "\n\n                    " +
                        _vm._s(
                          _vm.$translate(
                            "Weberbuero::Template.serviceSidebarCountryNotFound"
                          )
                        ) +
                        "\n                  "
                    )
                  ]
                )
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.activeLang != "contact"
            ? _c(
                "div",
                { staticClass: "shipping-profiles" },
                [
                  _vm._l(_vm.shippingGroup[_vm.activeLang], function(
                    group,
                    key,
                    index
                  ) {
                    return [
                      key >= _vm.shippingIndex
                        ? _c(
                            "div",
                            { staticClass: "shipping-profile__wrapper" },
                            [
                              key ===
                              _vm.shippingGroup[_vm.activeLang].length - 1
                                ? _c(
                                    "div",
                                    { staticClass: "shipping-profile__img" },
                                    [
                                      _vm.deliveryMapping === 4
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$translate(
                                                  "Weberbuero::Template.serviceModalOpenBtnIconSpedition"
                                                )
                                              )
                                            }
                                          })
                                        : _vm.deliveryMapping === 16
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$translate(
                                                  "Weberbuero::Template.serviceModalOpenBtnIconSpedition"
                                                )
                                              )
                                            }
                                          })
                                        : _vm.deliveryMapping === 6
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$translate(
                                                  "Weberbuero::Template.serviceModalOpenBtnIconPaketversandDhl"
                                                )
                                              )
                                            }
                                          })
                                        : _vm.deliveryMapping === 20
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$translate(
                                                  "Weberbuero::Template.serviceModalOpenBtnIconGLS"
                                                )
                                              )
                                            }
                                          })
                                        : _vm.deliveryMapping === 8
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$translate(
                                                  "Weberbuero::Template.serviceModalOpenBtnIconAbholung"
                                                )
                                              )
                                            }
                                          })
                                        : _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$translate(
                                                  "Weberbuero::Template.serviceModalOpenBtnIcon"
                                                )
                                              )
                                            }
                                          })
                                    ]
                                  )
                                : _c("img", {
                                    staticClass: "shipping-profile__img",
                                    attrs: { src: group.icon, alt: group.name }
                                  }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "shipping-profile__content" },
                                [
                                  key ===
                                  _vm.shippingGroup[_vm.activeLang].length - 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "shipping-profile__name"
                                        },
                                        [
                                          _vm.deliveryMapping === 4
                                            ? [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Weberbuero::Template.serviceModalOpenBtnLeftPaketversandDhl"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            : _vm.deliveryMapping === 16
                                            ? [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Weberbuero::Template.serviceModalOpenBtnLeftSpedition"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            : _vm.deliveryMapping === 6
                                            ? [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Weberbuero::Template.serviceModalOpenBtnLeftPaketversandDhl"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            : _vm.deliveryMapping === 20
                                            ? [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Weberbuero::Template.serviceModalOpenBtnLeftGLS"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            : _vm.deliveryMapping === 8
                                            ? [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Weberbuero::Template.serviceModalOpenBtnLeftAbholung"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Weberbuero::Template.serviceModalOpenBtnLeft"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                        ],
                                        2
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "shipping-profile__name"
                                        },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(group.name) +
                                              "\n                      "
                                          )
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "shipping-profile__price" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            group.article1.toLocaleString(
                                              "de-DE",
                                              {
                                                style: "currency",
                                                currency: "EUR"
                                              }
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          " - Jeder weitere Artikel: " +
                                            _vm._s(
                                              group.article2.toLocaleString(
                                                "de-DE",
                                                {
                                                  style: "currency",
                                                  currency: "EUR"
                                                }
                                              )
                                            )
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            : _c("div", { staticClass: "contact-box__wrapper" }, [
                _c("div", { staticClass: "contact-box__headline" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Weberbuero::Template.serviceSidebarContactHeadline"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "contact-box__text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Weberbuero::Template.serviceSidebarContactText"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "contact-box__btn",
                    attrs: {
                      href: _vm.$translate(
                        "Weberbuero::Template.serviceSidebarContactBtnUrl"
                      )
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceSidebarContactBtn"
                        )
                      )
                    )
                  ]
                )
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-faq__wrapper" }, [
            _c("div", { staticClass: "sidebar-faq__headline" }, [
              _vm._v(
                _vm._s(
                  _vm.$translate(
                    "Weberbuero::Template.serviceSidebarFaqHeadline"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sidebar-faq__item" }, [
              _c(
                "div",
                {
                  staticClass: "sidebar-faq__item-title",
                  class: { open: _vm.faq1Open },
                  on: {
                    click: function($event) {
                      _vm.faq1Open = !_vm.faq1Open
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceSidebarFaqItem1Headline"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "8",
                        viewBox: "0 0 12 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "01 shape",
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d:
                            "M11.0024 0.400391L6 5.54733L0.997554 0.400391L0 1.42676L6 7.60006L12 1.42676L11.0024 0.400391Z",
                          fill: "#9B9B9B"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sidebar-faq__item-text",
                  style: _vm.faq1Open
                    ? "height:" + _vm.faq1TxtHeight
                    : "height: 0"
                },
                [
                  _c("div", {
                    ref: "faq1Txt",
                    staticClass: "sidebar-faq__item-text-inner",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceSidebarFaqItem1Text"
                        )
                      )
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sidebar-faq__item" }, [
              _c(
                "div",
                {
                  staticClass: "sidebar-faq__item-title",
                  class: { open: _vm.faq2Open },
                  on: {
                    click: function($event) {
                      _vm.faq2Open = !_vm.faq2Open
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceSidebarFaqItem2Headline"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "8",
                        viewBox: "0 0 12 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "01 shape",
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d:
                            "M11.0024 0.400391L6 5.54733L0.997554 0.400391L0 1.42676L6 7.60006L12 1.42676L11.0024 0.400391Z",
                          fill: "#9B9B9B"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sidebar-faq__item-text",
                  style: _vm.faq2Open
                    ? "height:" + _vm.faq2TxtHeight
                    : "height: 0"
                },
                [
                  _c("div", {
                    ref: "faq2Txt",
                    staticClass: "sidebar-faq__item-text-inner",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceSidebarFaqItem2Text"
                        )
                      )
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sidebar-faq__item" }, [
              _c(
                "div",
                {
                  staticClass: "sidebar-faq__item-title",
                  class: { open: _vm.faq3Open },
                  on: {
                    click: function($event) {
                      _vm.faq3Open = !_vm.faq3Open
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceSidebarFaqItem3Headline"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "8",
                        viewBox: "0 0 12 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "01 shape",
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d:
                            "M11.0024 0.400391L6 5.54733L0.997554 0.400391L0 1.42676L6 7.60006L12 1.42676L11.0024 0.400391Z",
                          fill: "#9B9B9B"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sidebar-faq__item-text",
                  style: _vm.faq3Open
                    ? "height:" + _vm.faq3TxtHeight
                    : "height: 0"
                },
                [
                  _c("div", {
                    ref: "faq3Txt",
                    staticClass: "sidebar-faq__item-text-inner",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate(
                          "Weberbuero::Template.serviceSidebarFaqItem3Text"
                        )
                      )
                    }
                  })
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }